import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule as TemplateFormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatRadioModule,
  MatSelectModule,
} from '@angular/material';
import { TextMaskModule } from 'angular2-text-mask';
import { AddressFormComponent } from './address-form/address-form.component';
import { FormsComponentsModule } from './components/forms-components.module';
import { FreightCostSimulationDialogComponent } from './freight-cost-simulation-dialog/freight-cost-simulation-dialog.component';
import { ShippingServiceFormComponent } from './shipping-service-form/shipping-service-form.component';
import { SimuladorFreteDialogComponent } from './simulador-frete-dialog/simulador-frete-dialog.component';
import { SimuladorFreteModule } from '../simulador-frete/simulador-frete.module';

@NgModule({
  declarations: [
    AddressFormComponent,
    FreightCostSimulationDialogComponent,
    ShippingServiceFormComponent,
    SimuladorFreteDialogComponent,
  ],
  imports: [
    CommonModule,
    TemplateFormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    ReactiveFormsModule,
    TextMaskModule,
    FormsComponentsModule,
    SimuladorFreteModule,
  ],
  entryComponents: [
    FreightCostSimulationDialogComponent,
    SimuladorFreteDialogComponent,
  ],
  exports: [
    AddressFormComponent,
    ShippingServiceFormComponent,
  ]
})
export class FormsModule { }
